import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Query } from "@oysterhr/schema"

import { PLAN_FRAGMENT } from "../../fragments/PlanFragment"

const COUNTRY_BENEFITS_OFFER_QUERY = gql`
  ${PLAN_FRAGMENT}
  query CountryBenefitsOffer(
    $engagementId: ID!
    $useSalaryCurrencyCode: Boolean
    $currencyCode: String!
    $engagementType: String!
  ) {
    benefitsOfferFor(engagementId: $engagementId) {
      tiers {
        collection {
          id
          name
          fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
            currencyCode
            subunit
            subunitToUnit
            formatted
          }
          includedPlans {
            ...PlanFragment
            costSplitAllowed
            dependentsConfig
          }
        }
      }
      addons {
        collection {
          ...PlanFragment
          costSplitAllowed
          dependentsConfig
        }
      }
    }
  }
`

interface UseBenefitsOfferProps {
  engagementId: string
  currencyCode: string
  engagementType: string
  useSalaryCurrencyCode?: boolean
}
export const useBenefitsOffer = ({
  engagementId,
  currencyCode,
  engagementType,
  useSalaryCurrencyCode = true,
}: UseBenefitsOfferProps) =>
  useQuery<Pick<Query, "benefitsOfferFor">>(COUNTRY_BENEFITS_OFFER_QUERY, {
    variables: { engagementId, useSalaryCurrencyCode, currencyCode, engagementType },
  })
